module.exports = "/_next/static/images/customer-review-sarah1-min-54367b7d13d9056acacd1031c2f83b2d.png.webp";